<template>
    <div>
        <section class="section-hero section-shaped my-0">
            <Particles id='tsparticles'
            class="section-header"
            :particlesInit="particlesInit"
            :particlesLoaded="particlesLoaded"
            :options= '{
                "background": {
                    "color": {
                        "value": colors.background
                    },
                    /*"image": "url(/img/theme/img-bg.jpg)",*/
                    "position": "50% 50%",
                    "repeat": "no-repeat",
                    "size": "cover"
                },
                "fullScreen": {
                    "zIndex": -1,
                    "enable": false
                },
                "interactivity": {
                    "events": {
                        "onHover": {
                            "enable": true,
                            "mode": colors.mode
                        }
                    },
                    "modes": {
                        "bubble": {
                            "distance": 400,
                            "duration": 2,
                            "opacity": 1,
                            /*"size": 100,*/
                            "divs": {
                                "distance": 200,
                                "duration": 0.4,
                                "mix": false,
                                "selectors": []
                            }
                        },
                        "grab": {
                            "distance": 400
                        },
                        "attract": {
                            "distance": 400,
                            "speed": 1
                        },
                        "repulse": {
                            "distance": 400,
                            "duration": 2,
                            "factor": 1,
                            "speed": 1
                        }
                    }
                },
                "particles": {
                    "color": {
                        "value": colors.bubble
                    },
                    "collisions": {
                        "bounce": {
                            "horizontal": {
                                "random": {
                                    "enable": true,
                                    "minimumValue": 0.5
                                },
                                "value": 1
                            },
                            "vertical": {
                                "random": {
                                    "enable": true,
                                    "minimumValue": 0.5
                                },
                                "value": 1
                            }
                        },
                        "enable": false,
                        "mode": "bounce",
                    },
                    
                    "move": {
                        "enable": true,
                        "outModes": {
                            "bottom": "out",
                            "left": "out",
                            "right": "out",
                            "top": "out"
                        },
                        "speed": 0.5
                    },
                    "number": {
                        "density": {
                            "enable": true
                        },
                        "value": 50
                    },
                    "opacity": {
                        "animation": {
                            "speed": 0.2,
                            "minimumValue": 0.1
                        }
                    },
                    "size": {
                        "random": {
                            "enable": true,
                            "minimumValue": 50
                        },
                        "value": 80,
                        "animation": {
                            "speed": 20,
                            "minimumValue": 50
                        }
                    }
                }
            }' />
            
            <div class="section-header shape-container d-flex align-items-center">
                <div class="col px-0">
                    <div class="row justify-content-center align-items-center">
                        <div :style="`{z-index: 999; position:relative; height: 100%;}`">
                            <img src="img/brand/splash-new.png"  width="600px"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import { loadFull } from "tsparticles";

function sample(array) {
    return array[Math.floor(Math.random()*array.length)]
}

export default {
    name: "Hero",
    beforeMount() {
        this.colors = this.pickColour();
    },
    data: () => {
        return {
            particlesInit: async (engine) => {
                await loadFull(engine);
            },
            colors: null
        }
    },
    methods: {
        particlesLoaded: function() {
            console.log("Particles have loaded");
        },
        pickColour: function() {
            var theme = sample([{
                bubble: "#99e550",
                background: "#6abe30",
            },{
                bubble: "#5b6ee1",
                background: "#3f3f74",
            },{
                bubble: "#d95763",
                background: "#ac3232",
            }])
            theme.mode = sample(["attract", "repulse"]);
            return theme;
        }
    }
};
</script>